import { c as _c } from "react/compiler-runtime";
/// <reference path="../../../@types/tiptap-react-menus.d.ts" />
import { IcoBold16, IcoChecklist16, IcoChevronDown16, IcoCode16, IcoItalic16, IcoLink16, IcoOrderedList16, IcoQuoteLeft16, IcoStrikethrough16, IcoText16, IcoUnderline16, IcoUnorderedList16 } from '@onefootprint/icons';
import { NodeSelection } from '@tiptap/pm/state';
import { CellSelection } from '@tiptap/pm/tables';
import type { Editor } from '@tiptap/react';
import { useEditorState } from '@tiptap/react';
import { BubbleMenu } from '@tiptap/react/menus';
import { useCallback, useEffect, useRef, useState } from 'react';
type BubbleToolbarProps = {
  editor: Editor;
};
type TurnIntoItem = {
  label: string;
  icon: React.ReactNode;
  isActive: () => boolean;
  command: () => void;
};
export const BubbleToolbar = t0 => {
  const $ = _c(124);
  const {
    editor
  } = t0;
  let t1;
  if ($[0] !== editor) {
    t1 = {
      editor,
      selector: _temp
    };
    $[0] = editor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const editorState = useEditorState(t1);
  const shouldShow = _temp2;
  const [showLinkInput, setShowLinkInput] = useState(false);
  const [showTurnInto, setShowTurnInto] = useState(false);
  const [dropdownAbove, setDropdownAbove] = useState(false);
  const [linkUrl, setLinkUrl] = useState("");
  const turnIntoRef = useRef(null);
  let t2;
  if ($[2] !== editor || $[3] !== linkUrl) {
    t2 = () => {
      if (linkUrl.trim()) {
        const url = linkUrl.startsWith("http") ? linkUrl : `https://${linkUrl}`;
        editor.chain().focus().setLink({
          href: url
        }).run();
      } else {
        editor.chain().focus().unsetLink().run();
      }
      setShowLinkInput(false);
      setLinkUrl("");
    };
    $[2] = editor;
    $[3] = linkUrl;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const setLink = t2;
  let t3;
  let t4;
  if ($[5] !== showTurnInto) {
    t3 = () => {
      if (!showTurnInto) {
        return;
      }
      const handleClick = e_0 => {
        if (turnIntoRef.current && !turnIntoRef.current.contains(e_0.target as Node)) {
          setShowTurnInto(false);
        }
      };
      document.addEventListener("mousedown", handleClick);
      return () => document.removeEventListener("mousedown", handleClick);
    };
    t4 = [showTurnInto];
    $[5] = showTurnInto;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IcoText16 />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== editorState.isBlockquote || $[10] !== editorState.isBulletList || $[11] !== editorState.isCodeBlock || $[12] !== editorState.isH1 || $[13] !== editorState.isH2 || $[14] !== editorState.isH3 || $[15] !== editorState.isOrderedList || $[16] !== editorState.isTaskList) {
    t6 = () => !editorState.isH1 && !editorState.isH2 && !editorState.isH3 && !editorState.isBulletList && !editorState.isOrderedList && !editorState.isTaskList && !editorState.isBlockquote && !editorState.isCodeBlock;
    $[9] = editorState.isBlockquote;
    $[10] = editorState.isBulletList;
    $[11] = editorState.isCodeBlock;
    $[12] = editorState.isH1;
    $[13] = editorState.isH2;
    $[14] = editorState.isH3;
    $[15] = editorState.isOrderedList;
    $[16] = editorState.isTaskList;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== editor) {
    t7 = () => editor.chain().focus().setParagraph().run();
    $[18] = editor;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let T0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t8;
  let t9;
  if ($[20] !== dropdownAbove || $[21] !== editor || $[22] !== editorState.isBlockquote || $[23] !== editorState.isBulletList || $[24] !== editorState.isCodeBlock || $[25] !== editorState.isH1 || $[26] !== editorState.isH2 || $[27] !== editorState.isH3 || $[28] !== editorState.isOrderedList || $[29] !== editorState.isTaskList || $[30] !== showTurnInto || $[31] !== t6 || $[32] !== t7) {
    const turnIntoItems = [{
      label: "Text",
      icon: t5,
      isActive: t6,
      command: t7
    }, {
      label: "Heading 1",
      icon: <span className="turn-into-text-icon">H1</span>,
      isActive: () => editorState.isH1,
      command: () => editor.chain().focus().toggleHeading({
        level: 1
      }).run()
    }, {
      label: "Heading 2",
      icon: <span className="turn-into-text-icon">H2</span>,
      isActive: () => editorState.isH2,
      command: () => editor.chain().focus().toggleHeading({
        level: 2
      }).run()
    }, {
      label: "Heading 3",
      icon: <span className="turn-into-text-icon">H3</span>,
      isActive: () => editorState.isH3,
      command: () => editor.chain().focus().toggleHeading({
        level: 3
      }).run()
    }, {
      label: "Bulleted list",
      icon: <IcoUnorderedList16 />,
      isActive: () => editorState.isBulletList,
      command: () => editor.chain().focus().toggleBulletList().run()
    }, {
      label: "Numbered list",
      icon: <IcoOrderedList16 />,
      isActive: () => editorState.isOrderedList,
      command: () => editor.chain().focus().toggleOrderedList().run()
    }, {
      label: "To-do list",
      icon: <IcoChecklist16 />,
      isActive: () => editorState.isTaskList,
      command: () => editor.chain().focus().toggleTaskList().run()
    }, {
      label: "Blockquote",
      icon: <IcoQuoteLeft16 />,
      isActive: () => editorState.isBlockquote,
      command: () => editor.chain().focus().toggleBlockquote().run()
    }, {
      label: "Code block",
      icon: <IcoCode16 />,
      isActive: () => editorState.isCodeBlock,
      command: () => editor.chain().focus().toggleCodeBlock().run()
    }];
    let t16;
    if ($[42] !== editorState.isBlockquote || $[43] !== editorState.isBulletList || $[44] !== editorState.isCodeBlock || $[45] !== editorState.isH1 || $[46] !== editorState.isH2 || $[47] !== editorState.isH3 || $[48] !== editorState.isOrderedList || $[49] !== editorState.isTaskList) {
      t16 = () => {
        if (editorState.isH1) {
          return "Heading 1";
        }
        if (editorState.isH2) {
          return "Heading 2";
        }
        if (editorState.isH3) {
          return "Heading 3";
        }
        if (editorState.isCodeBlock) {
          return "Code block";
        }
        if (editorState.isBlockquote) {
          return "Blockquote";
        }
        if (editorState.isTaskList) {
          return "To-do list";
        }
        if (editorState.isBulletList) {
          return "Bulleted list";
        }
        if (editorState.isOrderedList) {
          return "Numbered list";
        }
        return "Text";
      };
      $[42] = editorState.isBlockquote;
      $[43] = editorState.isBulletList;
      $[44] = editorState.isCodeBlock;
      $[45] = editorState.isH1;
      $[46] = editorState.isH2;
      $[47] = editorState.isH3;
      $[48] = editorState.isOrderedList;
      $[49] = editorState.isTaskList;
      $[50] = t16;
    } else {
      t16 = $[50];
    }
    const getCurrentBlockLabel = t16;
    T0 = BubbleMenu;
    t14 = editor;
    t15 = shouldShow;
    t13 = "bubble-toolbar-container";
    t12 = "bubble-toolbar";
    t8 = "turn-into-wrapper";
    t9 = turnIntoRef;
    let t17;
    if ($[51] !== showTurnInto) {
      t17 = () => {
        if (!showTurnInto && turnIntoRef.current) {
          const rect = turnIntoRef.current.getBoundingClientRect();
          const spaceBelow = window.innerHeight - rect.bottom;
          setDropdownAbove(spaceBelow < 400);
        }
        setShowTurnInto(_temp3);
      };
      $[51] = showTurnInto;
      $[52] = t17;
    } else {
      t17 = $[52];
    }
    const t18 = getCurrentBlockLabel();
    let t19;
    if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = <IcoChevronDown16 color="tertiary" />;
      $[53] = t19;
    } else {
      t19 = $[53];
    }
    if ($[54] !== t17 || $[55] !== t18) {
      t10 = <button type="button" className="bubble-btn turn-into-trigger" onClick={t17}>{t18}{t19}</button>;
      $[54] = t17;
      $[55] = t18;
      $[56] = t10;
    } else {
      t10 = $[56];
    }
    t11 = showTurnInto && <div className={`turn-into-dropdown ${dropdownAbove ? "turn-into-dropdown-above" : ""}`}><div className="turn-into-label">Turn into</div>{turnIntoItems.map(item => <button key={item.label} type="button" className={`turn-into-item ${item.isActive() ? "is-active" : ""}`} onClick={() => {
        item.command();
        setShowTurnInto(false);
      }}><span className="turn-into-icon">{item.icon}</span>{item.label}</button>)}</div>;
    $[20] = dropdownAbove;
    $[21] = editor;
    $[22] = editorState.isBlockquote;
    $[23] = editorState.isBulletList;
    $[24] = editorState.isCodeBlock;
    $[25] = editorState.isH1;
    $[26] = editorState.isH2;
    $[27] = editorState.isH3;
    $[28] = editorState.isOrderedList;
    $[29] = editorState.isTaskList;
    $[30] = showTurnInto;
    $[31] = t6;
    $[32] = t7;
    $[33] = T0;
    $[34] = t10;
    $[35] = t11;
    $[36] = t12;
    $[37] = t13;
    $[38] = t14;
    $[39] = t15;
    $[40] = t8;
    $[41] = t9;
  } else {
    T0 = $[33];
    t10 = $[34];
    t11 = $[35];
    t12 = $[36];
    t13 = $[37];
    t14 = $[38];
    t15 = $[39];
    t8 = $[40];
    t9 = $[41];
  }
  let t16;
  if ($[57] !== t10 || $[58] !== t11 || $[59] !== t8 || $[60] !== t9) {
    t16 = <div className={t8} ref={t9}>{t10}{t11}</div>;
    $[57] = t10;
    $[58] = t11;
    $[59] = t8;
    $[60] = t9;
    $[61] = t16;
  } else {
    t16 = $[61];
  }
  let t17;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <ToolbarDivider />;
    $[62] = t17;
  } else {
    t17 = $[62];
  }
  let t18;
  if ($[63] !== editor) {
    t18 = () => editor.chain().focus().toggleBold().run();
    $[63] = editor;
    $[64] = t18;
  } else {
    t18 = $[64];
  }
  let t19;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <IcoBold16 />;
    $[65] = t19;
  } else {
    t19 = $[65];
  }
  let t20;
  if ($[66] !== editorState.isBold || $[67] !== t18) {
    t20 = <ToolbarButton onClick={t18} active={editorState.isBold} label="Bold">{t19}</ToolbarButton>;
    $[66] = editorState.isBold;
    $[67] = t18;
    $[68] = t20;
  } else {
    t20 = $[68];
  }
  let t21;
  if ($[69] !== editor) {
    t21 = () => editor.chain().focus().toggleItalic().run();
    $[69] = editor;
    $[70] = t21;
  } else {
    t21 = $[70];
  }
  let t22;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <IcoItalic16 />;
    $[71] = t22;
  } else {
    t22 = $[71];
  }
  let t23;
  if ($[72] !== editorState.isItalic || $[73] !== t21) {
    t23 = <ToolbarButton onClick={t21} active={editorState.isItalic} label="Italic">{t22}</ToolbarButton>;
    $[72] = editorState.isItalic;
    $[73] = t21;
    $[74] = t23;
  } else {
    t23 = $[74];
  }
  let t24;
  if ($[75] !== editor) {
    t24 = () => editor.chain().focus().toggleUnderline().run();
    $[75] = editor;
    $[76] = t24;
  } else {
    t24 = $[76];
  }
  let t25;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <IcoUnderline16 />;
    $[77] = t25;
  } else {
    t25 = $[77];
  }
  let t26;
  if ($[78] !== editorState.isUnderline || $[79] !== t24) {
    t26 = <ToolbarButton onClick={t24} active={editorState.isUnderline} label="Underline">{t25}</ToolbarButton>;
    $[78] = editorState.isUnderline;
    $[79] = t24;
    $[80] = t26;
  } else {
    t26 = $[80];
  }
  let t27;
  if ($[81] !== editor) {
    t27 = () => editor.chain().focus().toggleStrike().run();
    $[81] = editor;
    $[82] = t27;
  } else {
    t27 = $[82];
  }
  let t28;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <IcoStrikethrough16 />;
    $[83] = t28;
  } else {
    t28 = $[83];
  }
  let t29;
  if ($[84] !== editorState.isStrike || $[85] !== t27) {
    t29 = <ToolbarButton onClick={t27} active={editorState.isStrike} label="Strikethrough">{t28}</ToolbarButton>;
    $[84] = editorState.isStrike;
    $[85] = t27;
    $[86] = t29;
  } else {
    t29 = $[86];
  }
  let t30;
  if ($[87] !== editor) {
    t30 = () => editor.chain().focus().toggleCode().run();
    $[87] = editor;
    $[88] = t30;
  } else {
    t30 = $[88];
  }
  let t31;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <IcoCode16 />;
    $[89] = t31;
  } else {
    t31 = $[89];
  }
  let t32;
  if ($[90] !== editorState.isCode || $[91] !== t30) {
    t32 = <ToolbarButton onClick={t30} active={editorState.isCode} label="Inline code">{t31}</ToolbarButton>;
    $[90] = editorState.isCode;
    $[91] = t30;
    $[92] = t32;
  } else {
    t32 = $[92];
  }
  let t33;
  if ($[93] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <ToolbarDivider />;
    $[93] = t33;
  } else {
    t33 = $[93];
  }
  let t34;
  if ($[94] !== editor || $[95] !== editorState.isLink || $[96] !== showLinkInput) {
    t34 = () => {
      if (showLinkInput) {
        setShowLinkInput(false);
        setLinkUrl("");
      } else {
        if (editorState.isLink) {
          editor.chain().focus().unsetLink().run();
        } else {
          setLinkUrl("");
          setShowLinkInput(true);
        }
      }
    };
    $[94] = editor;
    $[95] = editorState.isLink;
    $[96] = showLinkInput;
    $[97] = t34;
  } else {
    t34 = $[97];
  }
  const t35 = editorState.isLink || showLinkInput;
  let t36;
  if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <IcoLink16 />;
    $[98] = t36;
  } else {
    t36 = $[98];
  }
  let t37;
  if ($[99] !== t34 || $[100] !== t35) {
    t37 = <ToolbarButton onClick={t34} active={t35} label="Link">{t36}</ToolbarButton>;
    $[99] = t34;
    $[100] = t35;
    $[101] = t37;
  } else {
    t37 = $[101];
  }
  let t38;
  if ($[102] !== t12 || $[103] !== t16 || $[104] !== t20 || $[105] !== t23 || $[106] !== t26 || $[107] !== t29 || $[108] !== t32 || $[109] !== t37) {
    t38 = <div className={t12}>{t16}{t17}{t20}{t23}{t26}{t29}{t32}{t33}{t37}</div>;
    $[102] = t12;
    $[103] = t16;
    $[104] = t20;
    $[105] = t23;
    $[106] = t26;
    $[107] = t29;
    $[108] = t32;
    $[109] = t37;
    $[110] = t38;
  } else {
    t38 = $[110];
  }
  let t39;
  if ($[111] !== linkUrl || $[112] !== setLink || $[113] !== showLinkInput) {
    t39 = showLinkInput && <div className="bubble-link-bar"><input className="bubble-link-input" type="text" placeholder="Paste link" value={linkUrl} onChange={e_1 => setLinkUrl(e_1.target.value)} onKeyDown={e_2 => {
        if (e_2.key === "Enter") {
          setLink();
        }
        if (e_2.key === "Escape") {
          setShowLinkInput(false);
          setLinkUrl("");
        }
      }} /></div>;
    $[111] = linkUrl;
    $[112] = setLink;
    $[113] = showLinkInput;
    $[114] = t39;
  } else {
    t39 = $[114];
  }
  let t40;
  if ($[115] !== t13 || $[116] !== t38 || $[117] !== t39) {
    t40 = <div className={t13}>{t38}{t39}</div>;
    $[115] = t13;
    $[116] = t38;
    $[117] = t39;
    $[118] = t40;
  } else {
    t40 = $[118];
  }
  let t41;
  if ($[119] !== T0 || $[120] !== t14 || $[121] !== t15 || $[122] !== t40) {
    t41 = <T0 editor={t14} shouldShow={t15}>{t40}</T0>;
    $[119] = T0;
    $[120] = t14;
    $[121] = t15;
    $[122] = t40;
    $[123] = t41;
  } else {
    t41 = $[123];
  }
  return t41;
};
const ToolbarButton = t0 => {
  const $ = _c(5);
  const {
    onClick,
    active,
    label,
    children
  } = t0;
  const t1 = `bubble-btn ${active ? "is-active" : ""}`;
  let t2;
  if ($[0] !== children || $[1] !== label || $[2] !== onClick || $[3] !== t1) {
    t2 = <button type="button" className={t1} onClick={onClick} aria-label={label} title={label}>{children}</button>;
    $[0] = children;
    $[1] = label;
    $[2] = onClick;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const ToolbarDivider = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bubble-divider" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(t0) {
  const {
    editor: e
  } = t0;
  return {
    isBold: e.isActive("bold"),
    isItalic: e.isActive("italic"),
    isUnderline: e.isActive("underline"),
    isStrike: e.isActive("strike"),
    isCode: e.isActive("code"),
    isLink: e.isActive("link"),
    isH1: e.isActive("heading", {
      level: 1
    }),
    isH2: e.isActive("heading", {
      level: 2
    }),
    isH3: e.isActive("heading", {
      level: 3
    }),
    isBulletList: e.isActive("bulletList"),
    isOrderedList: e.isActive("orderedList"),
    isTaskList: e.isActive("taskList"),
    isBlockquote: e.isActive("blockquote"),
    isCodeBlock: e.isActive("codeBlock")
  };
}
function _temp2(t0) {
  const {
    state
  } = t0;
  if (state.selection instanceof NodeSelection) {
    return false;
  }
  if (state.selection instanceof CellSelection) {
    return false;
  }
  if (state.selection.empty) {
    return false;
  }
  return true;
}
function _temp3(prev) {
  return !prev;
}